(function () {
  var VARIANT = '[data-fh-upsell-variant]';
  var PREV = '[data-fh-carousel-prev]';
  var NEXT = '[data-fh-carousel-next]';
  var TRACK = '[data-fh-carousel-track]';

  function syncVariant(select) {
    var option = select.options[select.selectedIndex];
    if (!option) return;

    var form = document.getElementById(select.getAttribute('data-form'));
    if (form) {
      var input = form.querySelector('input[name="id"]');
      if (input) input.value = option.value;

      var submit = form.querySelector('[name="add"]');
      if (submit) {
        if (option.disabled) submit.setAttribute('disabled', '');
        else submit.removeAttribute('disabled');
      }
    }

    var tile = select.closest('.upcart-internal-component-upsell-tile');
    if (!tile) return;

    var price = tile.querySelector('[data-upcart-chunk="upsell-new-price"]');
    if (price && option.dataset.price) price.textContent = option.dataset.price;

    var compare = tile.querySelector('[data-upcart-chunk="upsell-old-price"]');
    if (compare) {
      if (option.dataset.compare) {
        compare.textContent = option.dataset.compare;
        compare.hidden = false;
      } else {
        compare.textContent = '';
        compare.hidden = true;
      }
    }
  }

  function move(button, delta) {
    var container = button.closest('.upcart-internal-component-carousel__container');
    if (!container) return;

    var track = container.querySelector(TRACK);
    if (!track) return;

    var count = parseInt(track.getAttribute('data-count'), 10) || 1;
    var index = parseInt(track.getAttribute('data-index'), 10) || 0;

    index = Math.max(0, Math.min(count - 1, index + delta));
    track.setAttribute('data-index', index);
    track.style.transform = 'translateX(' + index * -100 + '%)';

    var prev = container.querySelector(PREV);
    var next = container.querySelector(NEXT);
    if (prev) prev.disabled = index === 0;
    if (next) next.disabled = index >= count - 1;
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;

    var prev = t.closest(PREV);
    if (prev) {
      e.preventDefault();
      move(prev, -1);
      return;
    }

    var next = t.closest(NEXT);
    if (next) {
      e.preventDefault();
      move(next, 1);
    }
  });

  document.addEventListener('change', function (e) {
    var select = e.target && e.target.closest ? e.target.closest(VARIANT) : null;
    if (select) syncVariant(select);
  });
})();
